/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AccessionPrefix } from './AccessionPrefix';
import type { AdminLabOrder } from './AdminLabOrder';
import type { Block } from './Block';
import type { Patient } from './Patient';
import type { Specimen } from './Specimen';
import type { UserContact } from './UserContact';
import type { UserName } from './UserName';

export type CasesAdmin = {
    readonly id?: number;
    patient: Patient;
    readonly created_at?: string;
    readonly updated_at?: string;
    /**
     * A secondary or external accession for the same case from the system that provided the data to WPL, e.g. Poplar, RPA.
     */
    external_accession?: string | null;
    ordering_doctor: UserContact;
    supervising_physician: UserContact;
    /**
     * date/time that we received a WPL order message indicating grossing was completed. This will match the order_message FK.
     */
    gross_completed?: string | null;
    blocks: Array<Block>;
    /**
     * date/time that we received a WPL order message indicating accessioning was completed
     */
    accession_completed?: string | null;
    priority?: CasesAdmin.priority;
    /**
     * current workflow status of the case
     */
    status?: CasesAdmin.status;
    active_assignment: UserName;
    readonly screen_assignment_id?: number;
    readonly finalize_assignment_id?: number;
    is_screening?: boolean;
    is_request_screen_complete?: boolean;
    is_manually_accessioned?: boolean | null;
    accession_prefix: AccessionPrefix;
    specimens: Array<Specimen>;
    lab_orders: Array<AdminLabOrder>;
    readonly high_res_removal_date?: string;
    readonly finalized_report_id?: number;
    readonly prelim_report_id?: number;
    working_reasons: any;
    /**
     * case origin, WPL or PW LIS
     */
    source?: CasesAdmin.source;
    /**
     * The Accession Number of the Case
     */
    readonly accession?: string | null;
}

export namespace CasesAdmin {

    export enum priority {
        RUSH = 'rush',
        STAT = 'stat',
        NORMAL = 'normal',
    }

    /**
     * current workflow status of the case
     */
    export enum status {
        ORDERED = 'ordered',
        ACTIVE = 'active',
        WORKING = 'working',
        FLAGGED = 'flagged',
        FINALIZED = 'finalized',
        DELETED = 'deleted',
        ARCHIVED = 'archived',
        LIS_PENDING = 'lis-pending',
        ERROR = 'error',
    }

    /**
     * case origin, WPL or PW LIS
     */
    export enum source {
        WPL = 'wpl',
        PW = 'pw',
        APL = 'apl',
    }


}
